module.exports = __webpack_public_path__ + "static/img/detect09.a820a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect09.png
// module id = 583
// module chunks = 4